import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DirectionService } from '../../direction.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { GeneralManagementService } from '../../super-management/general-management.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-helpers',
  templateUrl: './helpers.component.html',
  styleUrls: ['./helpers.component.css'],
  host: {
    class: 'fill-screen',
  },
})
export class HelpersComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading = false;
  isRemoving = false;

  currentRoute: string = ''; // 'helpers' | 'support' | 'remove'
  userId: string;
  printingService: string;
  branchOrPrinterId: string;

  constructor(
    private directionService: DirectionService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private generalManagementService: GeneralManagementService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) { }

  /** /helpers ו-/support – אותה תצוגה; רק טקסט הווצאפ שונה. */
  isHelpersOrSupportRoute(): boolean {
    return this.currentRoute === 'helpers' || this.currentRoute === 'support';
  }

  ngOnInit() {
    this.isLoading = true;

    this.directionSubscription = this.directionService.direction$.subscribe(
      (direction) => {
        this.isRTL = direction === 'rtl';
      }
    );

    this.directionService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    // Get current route and user ID
    this.route.url.subscribe(url => {
      if (url.length > 0) {
        this.currentRoute = url[0].path; // 'helpers' | 'support' | 'remove'
      }
      
      // Get user ID based on route
      this.route.queryParams.subscribe(params => {
        if (this.currentRoute === 'remove') {
          // For /remove route, get userId from query param 'x'
          this.userId = params['x'];
        } else {
          // For /helpers and /support, use AuthService
          this.userId = this.authService.getUserId();
        }
        
        // Debug log to see what we're getting
        console.log('Query params:', params);
        console.log('currentRoute:', this.currentRoute);
        console.log('userId:', this.userId);
      });
      
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
  }

  onButtonClick() {
    if (this.currentRoute === 'helpers') {
      this.openWhatsApp('Eazix-Helper');
    } else if (this.currentRoute === 'support') {
      this.openWhatsApp('Eazix-Support');
    } else if (this.currentRoute === 'remove') {
      this.removeFromDistributionList();
    }
  }

  openWhatsApp(msg: string) {
    const phoneNumber = '97233746962';
    const message = encodeURIComponent(msg);
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  removeFromDistributionList() {
    // Validate that we have userId
    if (!this.userId) {
      console.error('Missing required data for removal: userId is missing');
      // Show error message to user
      this.snackBar.open(
        this.translate.instant('helpers.missing-data-error-content'),
        '',
        {
          duration: 5000,
          verticalPosition: 'top'
        }
      );
      return;
    }

    // Validate that userId is a valid MongoDB ObjectId (24 hex characters)
    const objectIdPattern = /^[0-9a-fA-F]{24}$/;
    if (!objectIdPattern.test(this.userId)) {
      console.error('Invalid userId format (expected ObjectId, got):', this.userId);
      this.snackBar.open(
        this.translate.instant('helpers.invalid-id-error-content'),
        '',
        {
          duration: 5000,
          verticalPosition: 'top'
        }
      );
      return;
    }

    this.isRemoving = true;

    // Send only userId to backend - backend will search all clusters
    this.generalManagementService.removeFromHelpersDistributionList(
      this.userId
    ).subscribe({
      next: (response) => {
        console.log('Removed from helpers distribution list successfully:', response);
        this.isRemoving = false;
        // Show success snackbar
        this.snackBar.open(
          this.translate.instant('helpers.remove-from-list.success'),
          '',
          {
            duration: 3000,
            verticalPosition: 'top'
          }
        );
        // Navigate to home after a short delay
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 1500);
      },
      error: (error) => {
        console.error('Error removing from helpers distribution list:', error);
        console.log('FULL ERROR RESPONSE (stringified):', JSON.stringify(error, null, 2));
        this.isRemoving = false;
        // Error dialog will be shown automatically by ErrorInterceptor
        // Don't close the dialog on error
      }
    });
  }

  goToNewOrder() {
    this.router.navigate(['/']);
  }
}

